// ============================================================================
// view.timeline — the broiler/layer Gantt, read locally
// ============================================================================
// /broiler/timeline rendered from TWO former-eager boot results reached through
// two different provider hooks: the ppp-v4 broiler batch blob off
// BatchesContext, and the layer batch directory off LayerContext.
// broiler.timeline.core owns both now, which is what lets `timeline` retire
// from the frozen app_store and layer_batches consumer lists in
// tests/fixtures/former-eager-dependencies.json.
//
// WHY THIS IS PERMANENT AND NOT PARTIAL.
//
// The view still calls useBatches(), and that is not a residual. It reads
// exactly one field off it — `tooltip`, with its setter — which is the hover
// position this same component writes on mouse-over. It is component state that
// happens to live in a provider because App's former render body owned it; the
// global boot never fills it, no boot value reaches it, and
// former_eager_evidence's own field map does not list it for any of the five
// reads. `setView` and `setPendingEdit` off UIContext are navigation writes for
// the same reason.
//
// `openEdit` is still a prop from BroilerEntry, and is likewise a write: it is
// App's batch-form opener, reached only when a batch has no name to navigate
// by.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.timeline',
  obligations: Object.freeze([Object.freeze({id: 'broiler.timeline.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
